import * as $ from 'jquery';

/** Ripple effect */
$(function ($) {
  $('.simples-button').on('mousedown', function (e) {
    var $self = $(this);
    if ($self.is('.simples-button--disabled')) {
      return;
    }
    if ($self.closest('[data-ripple]')) {
      e.stopPropagation();
    }

    var initPos = $self.css('position');
    var offs = $self.offset();
    var x = e.pageX - offs.left;
    var y = e.pageY - offs.top;
    var dia = Math.min(this.offsetHeight, this.offsetWidth, 100); // start diameter
    var $ripple = $('<div/>', { class: 'ripple', appendTo: $self });

    if (!initPos || initPos === 'static') {
      $self.css({ position: 'relative' });
    }

    $('<div/>', {
      class: 'rippleWave',
      css: {
        background: $self.css('color'),
        width: dia,
        height: dia,
        left: x - dia / 2,
        top: y - dia / 2
      },
      appendTo: $ripple,
      one: {
        animationend: function () {
          $ripple.remove();
        }
      }
    });
  });
});
